module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown messages-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown"
    }
  }, [_vm._v(_vm._s(_vm.projectSelectedDisplay))]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("You have " + _vm._s(_vm.listData.length) + " project(s)")]), _vm._v(" "), (_vm.listData.length > 0) ? _c('li', [_c('ul', {
    staticClass: "menu"
  }, _vm._l((_vm.listData), function(project) {
    return _c('project-item', {
      key: project.id,
      attrs: {
        "project": project
      },
      on: {
        "onChooseProject": function($event) {
          _vm.chooseSelectedProject($event)
        }
      }
    })
  }))]) : _vm._e(), _vm._v(" "), (_vm.listData.length > 1) ? _c('li', {
    staticClass: "footer"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.onChooseAllProject()
      }
    }
  }, [_vm._v("View All Project(s)")])]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9f03c30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/ProjectMenu.vue
// module id = 781
// module chunks = 1